import { Button } from '@brain/ui'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { reportError } from '../lib/error-report.ts'

/** A page crashed while rendering or loading: reported to the Fehlerprotokoll (ADR 0022), with a way out. */
export function ErrorFallback({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation()
  useEffect(() => reportError('render', error), [error])
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-3 bg-page px-4 text-center">
      <p className="text-[15px] text-text-1">{t('errors.pageCrashed')}</p>
      <p className="max-w-sm text-[13px] text-meta">{t('errors.pageCrashedHint')}</p>
      <p className="max-w-md truncate font-mono text-[12px] text-meta">
        {error instanceof Error ? error.message : String(error)}
      </p>
      <div className="flex gap-2">
        <Button variant="ghost" onClick={reset}>
          {t('errors.retry')}
        </Button>
        <Button onClick={() => window.location.reload()}>{t('common.reload')}</Button>
      </div>
    </div>
  )
}
